var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowMob(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.28009 5.02002H1.8501V6.44995H3.28009V5.02002Z",
    fill: "#ADADAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70979 3.58997H3.27979V5.02002H4.70979V3.58997Z",
    fill: "#ADADAD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13995 2.16003H4.70996V3.58997H6.13995V2.16003Z",
    fill: "#ADADAD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55988 0.72998H6.12988V2.16003H7.55988V0.72998Z",
    fill: "#ADADAD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99007 2.16003H7.56006V3.58997H8.99007V2.16003Z",
    fill: "#ADADAD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4202 3.58997H8.99023V5.02002H10.4202V3.58997Z",
    fill: "#ADADAD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8499 5.02002H10.4199V6.44995H11.8499V5.02002Z",
    fill: "#ADADAD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowMob);
export default __webpack_public_path__ + "static/media/arrow-mob.f6b26fd158eb09903d9225a9e83af3d0.svg";
export { ForwardRef as ReactComponent };